import useSWR from "swr";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Truck, AlertTriangle, ArrowRight, Route as RouteIcon } from "lucide-react";
import { fetcher } from "@/lib/api";
import "@/i18n/fase8";

export default function FleetStatusWidget() {
  const { t } = useTranslation();
  const { data } = useSWR("/frota/aggregate/kpis", fetcher, { refreshInterval: 60000 });

  if (!data) {
    return (
      <div className="rounded-2xl border hairline bg-white p-6 min-h-[168px] animate-pulse" data-testid="fleet-widget-skeleton">
        <div className="h-4 w-32 bg-salnes-sand/60 rounded" />
      </div>
    );
  }

  const stale = data?.activity_24h?.stale_gps || 0;
  const active = data?.activity_24h?.plates_active ?? 0;
  const km24h = data?.activity_24h?.total_km ?? 0;
  const total = data?.total ?? 0;

  return (
    <Link
      to="/app/frota"
      className="rounded-2xl border hairline bg-white p-6 block hover:shadow-lg transition-all group"
      data-testid="fleet-widget"
    >
      <div className="flex items-center gap-2 mb-3 text-[11px] uppercase tracking-[0.22em] text-salnes-atlantic">
        <Truck size={14} strokeWidth={1.6} /> {t("fase8.dashboard_widget.fleet_title")}
      </div>
      <div className="flex items-baseline gap-3">
        <div className="font-serif text-4xl text-salnes-ink tabular-nums" data-testid="fleet-widget-active">
          {active}
        </div>
        <div className="text-sm text-salnes-stone">
          / {total} {t("fase8.dashboard_widget.fleet_active")}
        </div>
      </div>
      <div className="mt-2 text-xs text-salnes-stone flex items-center gap-1.5">
        <RouteIcon size={12} strokeWidth={1.6} />
        <b className="text-salnes-ink" data-testid="fleet-widget-km24h">{km24h.toLocaleString()}</b> {t("fase8.dashboard_widget.fleet_km_24h")}
      </div>
      {stale > 0 ? (
        <div
          className="mt-4 rounded-xl bg-salnes-coral/10 text-salnes-coral px-3 py-2 text-[11px] flex items-center gap-2"
          data-testid="fleet-widget-stale-alert"
        >
          <AlertTriangle size={14} strokeWidth={2} />
          {t("fase8.dashboard_widget.fleet_stale_alert", { n: stale })}
        </div>
      ) : (
        <div className="mt-4 text-[11px] text-salnes-stone/80 italic" data-testid="fleet-widget-no-alert">
          {t("fase8.dashboard_widget.fleet_no_alerts")}
        </div>
      )}
      <div className="mt-4 inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.18em] text-salnes-atlantic group-hover:gap-2 transition-all">
        {t("fase8.dashboard_widget.fleet_link")}
        <ArrowRight size={12} />
      </div>
    </Link>
  );
}
